import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../../../assets/img/icons/category.svg'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xl-4 col-lg-5 mb-4" }
const _hoisted_3 = { class: "card border-0 shadow-sm rounded-3 h-100" }
const _hoisted_4 = { class: "card-body d-flex flex-column align-items-center justify-content-center p-xl-5" }
const _hoisted_5 = {
  class: "single-product-img text-center mb-4 p-4 bg_ash rounded-3 w-100 d-flex justify-content-center align-items-center",
  style: {"min-height":"250px"}
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "text-muted d-flex flex-column align-items-center"
}
const _hoisted_8 = { class: "w-100 d-flex flex-column align-items-center bg_ash rounded-3 p-4" }
const _hoisted_9 = { class: "bg-white p-3 rounded-2 w-100 d-flex justify-content-center mb-3 shadow-sm" }
const _hoisted_10 = {
  key: 1,
  class: "text-muted fs-12"
}
const _hoisted_11 = { class: "bg-white p-3 rounded-2 w-100 d-flex justify-content-center shadow-sm" }
const _hoisted_12 = {
  key: 1,
  class: "text-muted fs-12"
}
const _hoisted_13 = { class: "col-xl-8 col-lg-7" }
const _hoisted_14 = { class: "card border-0 shadow-sm rounded-3 mb-4" }
const _hoisted_15 = { class: "card-body p-xl-4" }
const _hoisted_16 = { class: "list-group list-group-flush border-top-0" }
const _hoisted_17 = { class: "list-group-item d-flex justify-content-between align-items-center px-0 py-3 border-bottom border-light" }
const _hoisted_18 = { class: "fw-semibold text-title fs-14" }
const _hoisted_19 = { class: "list-group-item d-flex justify-content-between align-items-center px-0 py-3 border-bottom border-light" }
const _hoisted_20 = { class: "fw-bold text-primary fs-15" }
const _hoisted_21 = { class: "list-group-item d-flex justify-content-between align-items-center px-0 py-3 border-bottom border-light" }
const _hoisted_22 = { class: "badge bg_ash text-title fs-13 py-2 px-3 fw-medium" }
const _hoisted_23 = { class: "list-group-item d-flex justify-content-between align-items-center px-0 py-3 border-bottom border-light" }
const _hoisted_24 = { class: "fw-semibold text-title fs-14" }
const _hoisted_25 = { class: "list-group-item d-flex justify-content-between align-items-center px-0 py-3 border-bottom border-light" }
const _hoisted_26 = { class: "fw-semibold text-title fs-14" }
const _hoisted_27 = { class: "list-group-item d-flex justify-content-between align-items-center px-0 py-3 border-bottom border-light" }
const _hoisted_28 = { class: "fw-semibold text-title fs-14 text-end" }
const _hoisted_29 = { class: "list-group-item d-flex justify-content-between align-items-center px-0 py-3 border-bottom border-light" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-6 mb-4" }
const _hoisted_32 = { class: "card border-0 shadow-sm rounded-3 h-100" }
const _hoisted_33 = { class: "card-body p-xl-4" }
const _hoisted_34 = { class: "list-group list-group-flush border-top-0" }
const _hoisted_35 = { class: "list-group-item d-flex justify-content-between align-items-center px-0 py-3 border-bottom border-light" }
const _hoisted_36 = { class: "fw-semibold text-danger fs-14" }
const _hoisted_37 = { class: "list-group-item d-flex justify-content-between align-items-center px-0 py-3 border-bottom border-light" }
const _hoisted_38 = { class: "fw-bold text-success fs-15" }
const _hoisted_39 = { class: "col-md-6 mb-4" }
const _hoisted_40 = { class: "card border-0 shadow-sm rounded-3 h-100" }
const _hoisted_41 = { class: "card-body p-xl-4" }
const _hoisted_42 = { class: "stock-summary-box rounded-3 px-3 py-4 mb-4" }
const _hoisted_43 = { class: "text-muted fs-13 mb-1" }
const _hoisted_44 = { class: "fw-bold text-title fs-24" }
const _hoisted_45 = {
  key: 0,
  class: "warehouse-stock-list"
}
const _hoisted_46 = { class: "fw-semibold text-title fs-14" }
const _hoisted_47 = { class: "text-muted fs-12" }
const _hoisted_48 = { class: "badge stock-badge" }
const _hoisted_49 = {
  key: 1,
  class: "text-muted fs-14"
}
const _hoisted_50 = {
  key: 0,
  class: "alert alert-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarcodeGenerator = _resolveComponent("BarcodeGenerator")!
  const _component_QRCodeGenerator = _resolveComponent("QRCodeGenerator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "card-header bg-transparent border-bottom-0 pt-4 pb-0 text-center" }, [
            _createElementVNode("h6", { class: "fw-semibold mb-0" }, "Product Visuals")
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.imageUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.imageUrl,
                    alt: "Product",
                    class: "img-fluid",
                    style: {"max-height":"200px","object-fit":"contain"}
                  }, null, 8, _hoisted_6))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("img", {
                      src: _imports_0,
                      width: "48",
                      class: "mb-2 opacity-50"
                    }, null, -1),
                    _createElementVNode("span", null, "No Image Available", -1)
                  ]))]))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[1] || (_cache[1] = _createElementVNode("h6", { class: "fs-14 fw-semibold text-muted mb-3" }, "Identification Codes", -1)),
              _createElementVNode("div", _hoisted_9, [
                (_ctx.product?.code)
                  ? (_openBlock(), _createBlock(_component_BarcodeGenerator, {
                      key: 0,
                      value: _ctx.product.code,
                      height: 60,
                      width: 1.8
                    }, null, 8, ["value"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, "No Barcode"))
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_ctx.product?.code)
                  ? (_openBlock(), _createBlock(_component_QRCodeGenerator, {
                      key: 0,
                      value: _ctx.product.code,
                      size: 120
                    }, null, 8, ["value"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_12, "No QR Code"))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "card-header bg-transparent border-bottom-0 pt-4 pb-0" }, [
            _createElementVNode("h6", { class: "fw-semibold mb-0" }, "General Information")
          ], -1)),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("ul", _hoisted_16, [
              _createElementVNode("li", _hoisted_17, [
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-muted fs-14" }, "Product Code", -1)),
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.product?.code || 'N/A'), 1)
              ]),
              _createElementVNode("li", _hoisted_19, [
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-muted fs-14" }, "Product Name", -1)),
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.product?.name || 'N/A'), 1)
              ]),
              _createElementVNode("li", _hoisted_21, [
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-muted fs-14" }, "Category", -1)),
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.product?.category?.name || 'N/A'), 1)
              ]),
              _createElementVNode("li", _hoisted_23, [
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-muted fs-14" }, "Brand", -1)),
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.product?.brand?.name || 'N/A'), 1)
              ]),
              _createElementVNode("li", _hoisted_25, [
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-muted fs-14" }, "Base Unit", -1)),
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.product?.unit?.name || 'N/A'), 1)
              ]),
              _createElementVNode("li", _hoisted_27, [
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-muted fs-14" }, "Sizes", -1)),
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.sizeLabel), 1)
              ]),
              _createElementVNode("li", _hoisted_29, [
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-muted fs-14" }, "Public E-Menu", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.product?.show_on_emenu ? 'badge bg-success' : 'badge bg-secondary')
                }, _toDisplayString(_ctx.product?.show_on_emenu ? 'Enabled' : 'Disabled'), 3)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-header bg-transparent border-bottom-0 pt-4 pb-0" }, [
                _createElementVNode("h6", { class: "fw-semibold mb-0" }, "Pricing Breakdown")
              ], -1)),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("ul", _hoisted_34, [
                  _createElementVNode("li", _hoisted_35, [
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-muted fs-14" }, "Cost", -1)),
                    _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.formatCurrency(_ctx.product?.cost)), 1)
                  ]),
                  _createElementVNode("li", _hoisted_37, [
                    _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-muted fs-14" }, "Selling Price", -1)),
                    _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.formatCurrency(_ctx.product?.price)), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "card-header bg-transparent border-bottom-0 pt-4 pb-0" }, [
                _createElementVNode("h6", { class: "fw-semibold mb-0" }, "Stock Overview")
              ], -1)),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.stockSummaryLabel), 1),
                  _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.totalStock), 1)
                ]),
                (_ctx.visibleStocks.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleStocks, (stock) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `${stock.warehouse_id}-${stock.id || stock.product_id}`,
                          class: "warehouse-stock-item d-flex justify-content-between align-items-center rounded-3 px-3 py-3 mb-2"
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_46, _toDisplayString(stock.warehouse?.name || stock.warehouse_name || "Warehouse"), 1),
                            _createElementVNode("div", _hoisted_47, _toDisplayString(stock.warehouse_code || "No code"), 1)
                          ]),
                          _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.getStockQty(stock)), 1)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_49, "No stock records available."))
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ], 64))
}